import { Block } from "baseui/block"
import { FaFan } from "react-icons/fa"
import { VscRefresh } from "react-icons/vsc"
import { Rotate } from "../../../components/Rotate/Rotate"
import { schema, schemaFan, schemaOutput} from "../DriveOneSpeed"
import { schemaFan as schemaFanVarSpeed, schema as schemaVarSpeed } from "../DriveVarSpeed/types"
import { schemaFan as schemaFanTwoSpeed, schema as schemaTwoSpeed } from "../DriveTwoSpeed/types"
import { schemaFan as schemaFanThreeSpeed, schema as schemaThreeSpeed } from "../DriveThreeSpeed/types"
import { HeatingPump, HeatingPumpOn } from "./HeatingPump"
import { MotorIcon } from "./MotorIcon"
import { VscCircleLarge, VscPassFilled } from 'react-icons/vsc';
import { useStyletron } from "baseui"


const fans = [schemaFan, schemaFanVarSpeed, schemaFanTwoSpeed, schemaFanThreeSpeed];
const motors = [schema, schemaVarSpeed, schemaTwoSpeed, schemaThreeSpeed];
const output = [schemaOutput]

export const DriveIcon = (props: any) => {
    const [css] = useStyletron();
    if (fans.includes(props.schema))
        return (
            <>
                {props.isOn ?
                    <Rotate>
                        <FaFan color={props.color} size={props.size} />
                    </Rotate>
                    :
                    <FaFan color={props.color} size={props.size} />
                }
            </>
        )

    if (motors.includes(props.schema))
        return (
            <Block display='flex' flexDirection='row' alignItems='center' gridGap='5px'>
                {props.isOn &&
                <Rotate style={{ width: 'calc(' + props.size + '/2)', height: 'calc(' + props.size + '/2)' }}>
                    <VscRefresh size='100%' color={props.color}></VscRefresh>
                </Rotate> }
                <MotorIcon width={props.size} height={props.size} color={props.color}></MotorIcon>
            </Block>
        )
    if (output.includes(props.schema))
        return (
            <Block display='flex' flexDirection='row' alignItems='center' gridGap='5px'>
                {props.isOn &&
                
                    <VscPassFilled width={props.size} height={props.size} color={props.color}></VscPassFilled>
                }
                {!props.isOn &&
                <VscCircleLarge width={props.size} height={props.size} color={props.color}></VscCircleLarge>
}   
            </Block>
        )
    // pumps
    return (
        <div className={css({ position: 'relative', width: props.size, height: props.size })}>
            {props.isOn && <div  className={css({ position: 'absolute', top: 'calc(' + props.size + ' / 2 + 15px)', right: props.size, width: props.size, height: props.size })}> <HeatingPumpOn ></HeatingPumpOn></div>}
            {props.isOn && <div className={css({ position: 'absolute', top: 'calc(' + props.size + ' / 2 + 15px)', left: 'calc(' + props.size + ' - 5px)', width: props.size, height: props.size })}> <HeatingPumpOn ></HeatingPumpOn></div>}
            <HeatingPump className={css({ position: 'absolute', top: '0px', left: '0px', width: '100%', height: '100%' })} color={props.color} />
        </div>
    )
}

export const DriveIconSimple = (props: any) => {
    if (fans.includes(props.schema))
        return (
            <FaFan color={props.color} size={props.size} />
        )

    if (output.includes(props.schema))
        return (
            <VscCircleLarge color={props.color} size={props.size} />
        )

    if (motors.includes(props.schema))
        return (
            <MotorIcon width={props.size} height={props.size} color={props.color}></MotorIcon>
        )
    // pumps
    return (
        <HeatingPump width={props.size} height={props.size} color={props.color} />
    )
}